import { Page } from "@/models/page-models/Page";

export const MiscInvoiceCreate: Page = {
  "path": "new-misc-invoice",
  "name": "Create Miscellaneous Invoice",
  "props": {
    "data": {
      "title": "Create Miscellaneous Invoice",
      "printable": "FALSE",
      "url": "new-misc-invoice",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer.id",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedCustomerDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCustomer"
                      },
                      "name": "copySelectedCustomerDetails"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyVatPercentage",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getVatPercentage",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyVatPercentage"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.name",
                  "label": "Customer Name (billing name as per CR)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nameArabic",
                  "label": "Customer Arabic Name",
                  "disabled": "TRUE"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedCustomer.schemeId",
                  "label": "Customer ID Type (Scheme ID)",
                  "disabled": "TRUE",
                  "items": "[{\"text\":\"VAT Number\",\"value\":\"VAT\"},{\"text\":\"Tax Identification Number\",\"value\":\"TIN\"},{\"text\":\"Commercial registration number\",\"value\":\"CRN\"},{\"text\":\"MOMRAH license\",\"value\":\"MOM\"},{\"text\":\"MHRSD license\",\"value\":\"MLS\"},{\"text\":\"700 Number\",\"value\":\"700\"},{\"text\":\"MISA license\",\"value\":\"SAG\"},{\"text\":\"National ID\",\"value\":\"NAT\"},{\"text\":\"GCC ID\",\"value\":\"GCC\"},{\"text\":\"Iqama Number\",\"value\":\"IQA\"},{\"text\":\"Passport ID\",\"value\":\"PAS\"},{\"text\":\"Other ID\",\"value\":\"OTH\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.identification",
                  "label": "Customer ID #",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.streetName",
                  "label": "Street Name (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.buildNumber",
                  "label": "Building Number (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.buildNumber",
                  "label": "Building Number (ar)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.streetName",
                  "label": "Street Name (ar)",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.additionalNumber",
                  "label": "Additional Number (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.cityName",
                  "label": "City (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.cityName",
                  "label": "City (ar)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.additionalNumber",
                  "label": "Additional Number (ar)",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.postalCode",
                  "label": "Postal Code (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.district",
                  "label": "District (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.district",
                  "label": "District (ar)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.postalCode",
                  "label": "Postal Code (ar)",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.country",
                  "label": "Country (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.en.countryCode",
                  "label": "Country Code (en)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.countryCode",
                  "label": "Country Code (ar)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedCustomer.nationalAddress.ar.country",
                  "label": "Country (ar)",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.loadingManifest.typeOfDelivery",
                  "label": "Type of Delivery",
                  "disabled": "FALSE",
                  "items": "[\"Senddex\",\"Aramex\",\"Naqel\",\"Company Driver\",\"Third Party\",\"Customer Pickup\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.loadingManifest.trackingNo",
                  "label": "Tracking No",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.orders",
          "label": "Invoice Items",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "description",
                  "label": "Item Description",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "sellingUnit",
                  "label": "Selling Unit",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "quantity",
                  "label": "Quantity",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "unitPrice",
                  "label": "Unit Price",
                  "disabled": "FALSE"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_InvoiceDetails",
                  "variable": "formData",
                  "label": "Invoice Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedCustomer}}",
                  "config": {
                    "customerDetailsVariable": "fetchedData.selectedCustomer"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Invoice Orders",
                  "disabled": "FALSE",
                  "showIf": "{{formData.orders.0.description}}",
                  "items": "formData.orders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "width": 41,
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{formData.orders}}))"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل",
                      "width": 175
                    },
                    {
                      "value": "sellingUnit",
                      "text": "Unit\\nالوحدة",
                      "width": 66
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity\\nالكمية"
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price\\nالسعر",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.unitPrice}})"
                    },
                    {
                      "value": "value",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.unitPrice}},{{__item.quantity}}))",
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.unitPrice}},{{__item.quantity}},{{fetchedData.vatPercent}},0.01))",
                      "width": 100
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.unitPrice}},{{__item.quantity}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01))"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "variable": "formData.orders",
                  "label": "Sub Total",
                  "showIf": "{{formData.orders.0.description}}",
                  "disabled": "FALSE",
                  "config": {
                    "totalFormula": "fn(MULTIPLY,fn(SUM,100,{{fetchedData.vatPercent}}),0.01,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.unitPrice}},{{__arrayItem.quantity}}),{{formData.orders}}))",
                    "subTotalFormula": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.unitPrice}},{{__arrayItem.quantity}}),{{formData.orders}})",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Miscellaneous Invoice",
                  "disabled": "fn(NOT,{{formData.orders.0.description}})",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getFormattedOrdersArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.orders",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.orders",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getFormattedOrder"
                      },
                      "name": "getFormattedOrdersArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyTotalAndSubtotal",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getTotalAndSubtotal",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyTotalAndSubtotal"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "createMiscInvoice",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/misc-invoice/create",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "storeResponse",
                        "arg3Value": "TRUE"
                      },
                      "name": "createMiscInvoice"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "redirectToMiscInvoice",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/misc-invoice/{{__response.data._id}}"
                      },
                      "name": "redirectToMiscInvoice",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Invoice Preview"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showMisc=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      }
    ],
    "functions": [
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.selectedCustomer.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "getFormattedOrder",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "description": "{{__selectedObject.description}}",
          "sellingUnit": "{{__selectedObject.sellingUnit}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "0",
          "unitPrice": "{{__selectedObject.unitPrice}}",
          "value": "fn(MULTIPLY,{{__selectedObject.unitPrice}},{{__selectedObject.quantity}})"
        },
        "useFormula": true
      },
      {
        "name": "getTotalAndSubtotal",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "total": "fn(MULTIPLY,fn(SUM,100,{{fetchedData.vatPercent}}),0.01,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.unitPrice}},{{__arrayItem.quantity}}),{{formData.orders}}))",
          "subtotal": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.unitPrice}},{{__arrayItem.quantity}}),{{formData.orders}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}